import ChangeTracker from "./ChangeTracker";

export default class ToolOpionBackup {
  constructor(saveManager, toolOptionToggler, mulLangTexts) {
    this._saveManager = saveManager;
    this._mulLangTexts = mulLangTexts;
    this._toolOptionToggler = toolOptionToggler;
    this._elBackupDate = document.querySelector('#toolOptionGroup [name="backupDate"]');
    this._prevChangeCount = 0;
    this._backup = this._backup.bind(this);
    this._timeoutID = 0;
  }
  updateDates() {
    this._elBackupDate.innerHTML = '';
    this._saveManager.getBackupDates().then(dates => {
      dates.forEach(date => {
        const elOption = document.createElement('option');
        elOption.value = date.getTime();
        elOption.innerText = date.toLocaleString(navigator.language);
        this._elBackupDate.prepend(elOption);
      });
      this._elBackupDate.prepend(document.createElement('option'));
      this._elBackupDate.value = '';
    });
  }
  async _backup() {
    // console.log('backup check');
    const changeCount = ChangeTracker.changeCount;
    if(this._prevChangeCount !== changeCount) {
      // console.log('backup start');
      this._prevChangeCount = changeCount;
      await this._saveManager.backupPXARCH();
      this.updateDates();
    }
    this._timeoutID = 0;
    this.setBackup();
  }
  setBackup() {
    if(this._timeoutID) clearTimeout(this._timeoutID);
    this._timeoutID = setTimeout(this._backup, 1000 * 60 * 15);
  }
  load() {
    if(this._elBackupDate.value && window.confirm(this._mulLangTexts.get('CONFIRM_LOAD_BACKUP'))) {
      document.body.classList.add('dontTouchCuzloadingPXARCH');
      const date = new Date;
      date.setTime(this._elBackupDate.value);
      this._saveManager.loadBackup(date).catch(e => {
        alert(e.message);
        throw e;
      }).finally(() => {
        document.body.classList.remove('dontTouchCuzloadingPXARCH');
        this._prevChangeCount = 0;
        ChangeTracker.resetChangeCount();
        this.setBackup();
      });
      this._toolOptionToggler.close();
    }
  }
}
